import { render, staticRenderFns } from "./details-new.vue?vue&type=template&id=6e2a6daf&scoped=true"
import script from "./details-new.vue?vue&type=script&lang=js"
export * from "./details-new.vue?vue&type=script&lang=js"
import style0 from "./details-new.vue?vue&type=style&index=0&id=6e2a6daf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a6daf",
  null
  
)

export default component.exports